"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingProjectModal = void 0;
const react_1 = require("react");
const modal_context_1 = require("root/src/client/v2/common/contexts/modal.context");
const ModalLayout_1 = require("root/src/client/v2/common/layouts/ModalLayout");
const modalSuccessImg_png_1 = __importDefault(require("root/src/client/public/modalSuccessImg.png"));
const ButtonNew_1 = require("root/src/client/v2/common/components/form/ButtonNew");
exports.PendingProjectModal = (0, react_1.memo)(() => {
    const modal = (0, modal_context_1.useModal)();
    return (<ModalLayout_1.ModalLayout>
			<div className="flex flex-col gap-6 justify-center items-center">
				<h1 className="text-2xl font-bold text-center text-teal">Success</h1>
				<h2 className="text-lg text-center font-medium">Waiting for admin approval</h2>
				<img src={modalSuccessImg_png_1.default.src} alt="Success" className="w-36 h-36"/>
				<span className="font-bold text-center">Reward will be sent after approval by the administrator</span>
				<ButtonNew_1.ButtonNew className="uppercase font-bold px-8" onClick={() => modal.hide()}>Ok</ButtonNew_1.ButtonNew>
			</div>
		</ModalLayout_1.ModalLayout>);
});
